import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
// import React from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading
} from "../../Styles/InputStyle2"
import { Select, MenuItem } from "@mui/material";
// import tw from "tailwind-styled-components";
import { toast } from "react-toastify";



const EditBasicDetails = ({ setEditBasicAsset, addAssetFunctionMutate, isaddAssetLoading,stepOneData,setViewDetail }) => {

    const initialValues = {
        quantity: "",
        assetType: "Furniture & Fixtures",
        assetSubType: "Chairs",
        description: "",

    };

    const handleSubmit = (values) => {
        if (values.quantity > 200) {
            toast.error("Units should be less than 200");
            return;
        }
        const payload = {
            assetType: values.assetType,
            assetSubType: values.assetSubType,
            quantity: Number(values.quantity),
            description: values.description,
        }

        addAssetFunctionMutate(payload);

        // setSelectedForm("2");
    };

    const assetOptions = {
        "Furniture & Fixtures": [
            "Sofa",
            "Dining Table",
            "Chairs",
            "Bed & Mattress",
            "Wardrobe",
            "Coffee Table",
            "Study Table",
            "Bookshelf",
            "Shoe Rack",
            "Curtains & Blinds"
        ],
        "Electrical & Appliances": [
            "Air Conditioner (AC)",
            "Refrigerator",
            "Microwave Oven",
            "Washing Machine",
            "Ceiling Fan",
            "Geyser/Water Heater",
            "Water Purifier",
            "Induction Stove/Electric Stove",
            "LED/LCD TV",
            "Home Inverter & Battery",
            "CCTV Camera"
        ],
        "Plumbing & Sanitary": [
            "Water Pump",
            "Overhead Water Tank",
            "Sink & Faucet",
            "Toilet & Flush System",
            "Water Heater/Geyser",
            "Shower Set",
            "Drainage Pipes"
        ],
        "Security & Access Control": [
            "Door Locks & Smart Locks",
            "CCTV System",
            "Biometric Access System",
            "Intercom System",
            "Fire Alarm & Smoke Detectors",
            "Security Lights"
        ],
        "HVAC (Heating, Ventilation & Air Conditioning)": [
            "Centralized AC Unit",
            "Exhaust Fans",
            "Ventilation Ducts",
            "Air Purifier"
        ],
        "Outdoor & Common Area Assets": [
            "Garden Furniture",
            "Streetlights",
            "Parking Barriers",
            "Solar Panels",
            "Generator/Power Backup"
        ],
        "IT & Networking Equipment": [
            "WiFi Router",
            "Network Switch",
            "Server System",
            "Landline Phone"
        ],
        "Kitchen Equipment & Accessories": [
            "Gas Stove & Cylinder",
            "Chimney & Exhaust Fan",
            "Water Filter",
            "Dish Washer",
            "Kitchen Cabinets"
        ],
        "Miscellaneous Assets": [
            "Fire Extinguishers",
            "Elevators & Escalators",
            "Storage Racks",
            "Bulletin Boards & Notice Boards",
            "Signage & Nameplates"
        ]
    };


    const [selectedForm, setSelectedForm] = useState(null);

    const onClose = () => {
        setEditBasicAsset(false);
        setViewDetail(true);
    }
    const handleCross = () => {
        setEditBasicAsset(false);
        setViewDetail(true);
    }

    return (
        <Container>
            <Header>
                <Title>{"Edit Basic Details"}</Title>
                <CloseButton onClick={handleCross}>
                    <MdClose size={24} />
                </CloseButton>
            </Header>
            <Content>
                <Formik initialValues={stepOneData || initialValues} onSubmit={handleSubmit}>
                    {({ values, setFieldValue }) => (
                        <Form className="px-2">
                            {/* <ModalSubHeading>Step 1</ModalSubHeading> */}
                            {/* <ModalHeading>Basic Details</ModalHeading> */}
                            <ScrollableContent>
                                <Wrapper>
                                    <InputGroup>
                                        <Label>Asset Type *</Label>
                                        <Select
                                            value={values.assetType}
                                            onChange={(e) => {
                                                setFieldValue("assetType", e.target.value);
                                                setFieldValue("assetSubType", "");
                                            }}
                                            displayEmpty
                                            fullWidth
                                            className="px-2 bg-gray-100"
                                            disabled

                                        >
                                            <MenuItem value="" disabled>
                                                Select Asset Type
                                            </MenuItem>
                                            {Object.keys(assetOptions).map((type) => (
                                                <MenuItem key={type} value={type}>
                                                    {type}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </InputGroup>

                                    {values.assetType && (
                                        <InputGroup>
                                            <Label>Select {values.assetType} Type *</Label>
                                            <Select
                                                value={values.assetSubType}
                                                onChange={(e) => setFieldValue("assetSubType", e.target.value)}
                                                displayEmpty
                                                fullWidth
                                                className="px-2 bg-gray-100"
                                                disabled

                                            >
                                                <MenuItem value="" disabled>
                                                    Select {values.assetType} Option
                                                </MenuItem>
                                                {assetOptions[values.assetType].map((option) => (
                                                    <MenuItem key={option} value={option}>
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </InputGroup>
                                    )}

                                    <InputGroup>
                                        <Label htmlFor="quantity">Total Units *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="text"
                                                id="quantity"
                                                name="quantity"
                                                value={values.quantity}
                                                autoComplete="off"

                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                maxLength={10}
                                            />
                                        </FieldWrappers>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="description">Description </Label>

                                        <Field
                                            as={Textarea}
                                            id="description"
                                            name="description"
                                            rows={5}
                                            placeholder="Enter Description (e.g., Serial Number or Product Specifications)"
                                        />

                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={onClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit">
                                    Submit
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </Content>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`;


export default EditBasicDetails;